import { useEffect, useState } from 'react';

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState([null, null]);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize([window.innerWidth, window.innerHeight]);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return screenSize;
}